export default __webpack_public_path__ + "static/media/jntua.062d8d0b.jpg";